import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import IconButton from "mobily-ui-library/lib/components/composite/iconButton/IconButton";
import UploadDocument from "./UploadDocument";
import { useTranslation } from "react-i18next";
import { useContext, useState } from "react";
import { GlobalContext } from "../../../context/GlobalContext";
import { fileToBase64 } from "../../Util/FiletoBase64";
import HelpSection from "../../Common/HelpSection/HelpSection";
import { Form } from "antd";
import { useUploadJson } from "../uploadJson";


const win: any = window;

function DownloadUploadSection({ rtl }: any) {
  const dir = rtl ? "right" : "left";
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const uploadJson=useUploadJson();
  const [state, dispatch]: any = useContext(GlobalContext);
  const { productInformationData, userType } = state;
  
  const foundMNP = productInformationData.some(
    (item: any) => (item.productInformation?.orderType?.value === "Transfer your lines [MNP]" || item.productInformation?.orderType?.value === "Transfer Line lines MNP" || item.productInformation?.orderType?.value === "transferToMobily")
  );
  const emptyNew = state.productType !== 'Voice' || productInformationData.some(
    (item: any) => (item.productInformation?.orderType?.value === "New Activation")
  )
  let filterData = uploadJson.filter((item: any) =>
    item.userType.includes(state.userType) && item.productType.includes(state.productType)
  );

  if (!foundMNP) {
    filterData = filterData.filter(
      (item: any) =>
        item.title !== t("Transfer_Mobily_Document") && item.title !== t("CST_Consent_form_title")
    );
  }
  console.log(emptyNew, 'emptyNew', productInformationData)
  if (!emptyNew) {
    filterData = filterData.filter(
      (item: any) =>
        item.title !== t("Enduser_title")
    );
  }
  const initialValues = {

  }
  const [downloadDetails, setDownloadDetails] = useState<any>(filterData);

  const fileConverter = async (file: HTMLInputElement | any) => {
    const fileBaseRaw = await fileToBase64(file);
    const fileBase64 = await fileBaseRaw.split(';base64,');

    return await fileBase64[1];
  };
  const MAX_FILE_SIZE = 2 * 1024 * 1024;
  const selectFileHandler = async (e: any, selectedFile: any) => {
    if (selectedFile !== null) {

      if (selectedFile.size > MAX_FILE_SIZE) {
        errorMessageHandler(e.name, t("FileLimit_Validation"));
        return;
      }
      form.setFields([
        {
          name: e.name,
          errors: [],
        },
      ]);

      let { name } = e;
      const nameLower = name.replace(/ /g, "").toLowerCase();

      const newState = [...downloadDetails];
      const index = newState.findIndex(
        (item) => item.title.replace(/ /g, "").toLowerCase() === nameLower
      );
      const updatedState = { ...newState[index] };

      updatedState.file = await fileConverter(selectedFile);
      updatedState.fileSelected = true;
      updatedState.value = form.getFieldValue(name);
      updatedState["type"] = selectedFile.type;
      newState[index] = updatedState;
      setDownloadDetails(newState);
    } else {
      let value = e.alt;
      value = value.replace(/ /g, "").toLowerCase();

      const updateDetails = [...downloadDetails];
      const index = updateDetails.findIndex(
        (item) => item.title.replace(/ /g, "").toLowerCase() === value
      );

      const updatedState = { ...updateDetails[index] };
      updatedState.file = {};
      updatedState.fileSelected = false;
      updatedState.value = "";
      updatedState.isInvalid = false;

      updateDetails[index] = updatedState;
      setDownloadDetails(updateDetails);
    }
  };

  const errorMessageHandler = (name: string, error: any) => {
    if (error && error !== '') {
      form.setFields([
        {
            name,
            value: '',
            errors: [error],
        },
      ]);
    }
  };

  const handleClick = async () => {
    try {
      const res = await form.validateFields();
      console.log(res, 'res', form.getFieldsError())
      const hasFormErrors = form
        .getFieldsError()
        .some(({ errors }) => errors.length > 0);

      if (hasFormErrors) {
        return;
      }
      let updateForm = [...downloadDetails];

      updateForm = updateForm.map((item: any) => {
        if (item.value.length === 0 && item.fileSelected === false) {
          item.isInvalid = true;
          item.selectFileError = true;
        } else {
          item.isInvalid = false;
          item.selectFileError = false;
        }
        return item;
      });

      const fileDetails = updateForm.map((item, index) => {
        let file: any;
        if (item.fileSelected !== false && item.value.length !== 0) {
          file = {
            FileContentBinaryObject: item.file,
            Name: item.title,
            PathName: `./${item.title}`,
            MIMECode: item.type === "" ? 'application/vnd.ms-outlook' : item.type,
            SystemAdministrativeData: {
              CreationDateTime: state.createdTime,
            },
            VisibleIndicator: "true",
            VersioningEnabledIndicator: "false",
            CategoryCode: "2",
            TypeCode: item.typeCode,
          };
        }
        return file;
      });
      setDownloadDetails(updateForm);
      const hasInvalidFile = updateForm.some(
        (item: any) =>
          item.fileSelected === false ||
          item.value.length === 0
      );

      // Stop submission if invalid file exists
      if (hasInvalidFile) {
        setDownloadDetails(updateForm);
        return; 
      }
      // const found = userType === 'newcustomer' ? downloadDetails.some(
      //   (item: any) => item.fileSelected === false && item.value.length === 0
      // ) : false;
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
      dispatch({ type: "DOWNLOAD_ATTACHMENT_DATA", payload: { values: fileDetails, page: t("Download_Attach"), modalOpen: true } });
    } catch (error) {
      console.log(error);
      setDownloadDetails([...downloadDetails])
    }
  };

  return (
    <Form form={form} name="accordionForm" initialValues={initialValues} className="d-flex flex-column">
      <div className={`download-upload-section du-${dir}`}>
        <div className='ProductInformation__headerSection flex-column-reverse-mobile'>
          <div className={`product-information-text-container text-container-${dir} col-sm-8`}>
            <Typography rtl={rtl} className="form-title">{t("Download_Attach")}</Typography>
            <Typography rtl={rtl} className="product-information-text">{t("Document_Required")}</Typography>
          </div>
          <HelpSection rtl={rtl} />
        </div>
        {downloadDetails.map((item: any, index: any) => {
          console.log(form.getFieldError(item.title))
          return (
            <UploadDocument
              key={index}
              rtl={item.rtl}
              downloadForm={item.downloadForm}
              title={item.title}
              subTitle={item.subTitle}
              uploadFileText={item.uploadFileText}
              toolTipText={item.toolTipText}
              downloadFileSrc={item.downloadFileSrc}
              sizeErrorText={item.sizeErrorText}
              fileTypeErrorText={item.fileTypeErrorText}
              filemaxErrorText={item.filemaxErrorText}
              selectFileHandler={selectFileHandler}
              errorMessageHandler={errorMessageHandler}
              selectFileError={item.selectFileError}
              fileType={item.fileType}
              userType={item.userType}
              name={item.title}
              fileSupportPlaceholder={item.fileSupportPlaceholder || `${t('Supports_Files')}`}
              selectFileErrorText={form.getFieldError(item.title).join(' ')}
              rules={[
                {required: true, message: t('selectFileErrorText')}
              ]}
            />
          );
        })} 
      </div>
      <IconButton width={"130px"} htmlType='submit' rtl={rtl} className="next-button mt-2" onClick={handleClick}>
        {t("Next")}
      </IconButton>
    </Form>
  );
}

export default DownloadUploadSection;
